import { useEffect } from 'react';
import { eventToKeyCombo, isTypingTarget, serializeKeyCombo, useKeyboardContext } from '../contexts/KeyboardContext';

type Options = {
  preventDefault?: boolean; // impedir ações padrão quando houver match
  enabled?: boolean; // ativar/desativar dinamicamente
  ignoreWhenTyping?: boolean; // evitar atalhos quando escrevendo em inputs/textareas
};

export function useKeyboardShortcuts(options?: Options) {
  const { findBySerializedCombo, execute } = useKeyboardContext();

  useEffect(() => {
    if (options && options.enabled === false) return;

    const handler = (e: KeyboardEvent) => {
      if (options?.ignoreWhenTyping !== false && isTypingTarget(e.target)) return;
      const combo = eventToKeyCombo(e);
      const serialized = serializeKeyCombo(combo);
      if (!serialized) return;
      const bindings = findBySerializedCombo(serialized);
      if (bindings.length > 0) {
        if (options?.preventDefault !== false) {
          try { e.preventDefault(); } catch {}
        }
        // Executar todos os bindings associados a esta combinação
        for (const b of bindings) {
          execute(b.toolId, b.actionId);
        }
      }
    };

    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [findBySerializedCombo, execute, options?.preventDefault, options?.enabled, options?.ignoreWhenTyping]);
}


